module.exports = __webpack_public_path__ + "static/hero.cf220dbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/hero.jpg
// module id = 863
// module chunks = 114276838955818